import { DragDropProvider } from '@dnd-kit/react';
import { isSortable } from '@dnd-kit/react/sortable';
import { MuiRTL } from 'lib/MuiRTL';
import { useCallback } from 'react';

import SortableItem from './SortableItem';

const SortableList = ({
  items,
  onDelete,
  onDragEnd,
  canDelete = true,
  canReorder = true,
}) => {
  const handleDragEnd = useCallback(
    ({ canceled, operation }) => {
      if (!canReorder || canceled) {
        return;
      }

      const { source } = operation;

      if (!isSortable(source)) {
        return;
      }

      const { initialIndex, index } = source.sortable;

      if (initialIndex === index) {
        return;
      }

      onDragEnd?.({
        oldIndex: initialIndex,
        newIndex: index,
      });
    },
    [canReorder, onDragEnd],
  );

  return (
    <DragDropProvider onDragEnd={handleDragEnd}>
      <MuiRTL>
        <ul style={{ paddingRight: '24px', paddingLeft: '24px' }}>
          {items?.map((item, index) => (
            <SortableItem
              key={`item-${item.guid}`}
              onDelete={canDelete ? () => onDelete?.(item) : undefined}
              index={index}
              item={item}
              canDelete={canDelete}
              canReorder={canReorder}
            />
          ))}
        </ul>
      </MuiRTL>
    </DragDropProvider>
  );
};

export default SortableList;
